<script>
import { Bar, mixins } from "vue-chartjs";
const { reactiveProp } = mixins;

export default {
  extends: Bar,
  name: "BarChart",
  mixins: [reactiveProp],
  props: {
    chartData: {
      type: Object,
      required: false
    },
    singleChart: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      options: {
        onClick: this.handle,
        responsive: true,
        maintainAspectRatio: this.singleChart ? false : true,
        animation: {
          animateRotate: true
        },
        borderWidth: 1,
        legend: {
          display: false
        },
      },
    };
  },
  methods: {
    update() {
      this.$data._chart.update();
    },
    handle(point, event) {
      const item = event[0];
      this.$emit('redirectToEvent', item._model.label);
    },
  },
  mounted() {
    this.renderChart(this.chartData, this.options);
  }
};
</script>
